import { useQuery } from '@tanstack/react-query'

import { useAppDispatch, useAppSelector } from 'common/hooks/redux'

import { campaignKeys } from '../api/queryKeys'
import { fetchProjectsAsync } from '../store/campaignSlice'

const useProjectsQuery = () => {
  const dispatch = useAppDispatch()
  const accountId = useAppSelector((state) => state.authStates.accountId)

  return useQuery({
    queryKey: campaignKeys.projects(accountId),
    queryFn: () => dispatch(fetchProjectsAsync()).unwrap(),
    staleTime: Infinity,
  })
}

export default useProjectsQuery
